/*
 * DISTRIKT AUDIO: mobile sticky buy bar for standalone product pages. v1, 11 Oct 2026.
 * Loaded (defer) on product templates other than product.diva-bundle.
 * Every [data-dpt-atc] button clicks the real #AddToCart, so the cart drawer and all
 * pixel / Conversions API events run exactly as for a normal tap. Visible once the
 * real button has scrolled away; hidden again if a visible inline Add to cart button
 * (e.g. the bundle-options cards) comes into view.
 */
(function () {
  'use strict';

  var sticky = document.querySelector('[data-dpt-sticky]');
  var mainBtn = document.getElementById('AddToCart');
  if (!sticky || !mainBtn || !('IntersectionObserver' in window)) return;

  document.body.appendChild(sticky); // keep position:fixed out of transformed ancestors
  var sBtn = sticky.querySelector('.dpt-sticky__btn');
  var mq = window.matchMedia('(max-width: 767px)');
  var mainGone = false;
  var inlineSeen = new Set();

  function update() {
    var on = mq.matches && mainGone && inlineSeen.size === 0;
    sticky.classList.toggle('is-visible', on);
    sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    sBtn.tabIndex = on ? 0 : -1;
    document.body.classList.toggle('dpt-sticky-on', on);
  }

  new IntersectionObserver(function (es) {
    var e = es[0];
    mainGone = !e.isIntersecting && e.boundingClientRect.bottom < 0;
    update();
  }).observe(mainBtn.closest('.add_to_cart_holder') || mainBtn);

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) inlineSeen.add(e.target); else inlineSeen.delete(e.target); });
    update();
  });
  [].forEach.call(document.querySelectorAll('[data-dpt-atc-inline]'), function (b) { io.observe(b); });

  if (mq.addEventListener) mq.addEventListener('change', update);

  sBtn.addEventListener('click', function () { mainBtn.click(); });
})();
